import React, { useState, useEffect, useRef, useCallback } from 'react';
import classNames from 'classnames';
import './index.scss';

const containerDivIsInWindow = (containerDiv) => containerDiv.current.getBoundingClientRect().top > 0;

const scrollUp = (currentScroll, prevScroll) => prevScroll > currentScroll;

const containerDivIsOffWindow = (containerDiv) => containerDiv.current.getBoundingClientRect().top + containerDiv.current.clientHeight < 0;

const scrollDown = (currentScroll, prevScroll) => (prevScroll < currentScroll);

const StickyComponent = ({ children }) => {

    const [isSticky, toggleSticky] = useState(false);
    const [isVisible, toggleVisibility] = useState(false);
    const [prevScroll, setPrevScroll] = useState(0);
    const containerDiv = useRef(null);

    const handleScroll = useCallback((e) => {
        const currentScroll = e.currentTarget.scrollY;

        if (scrollDown(currentScroll, prevScroll) && containerDivIsOffWindow(containerDiv)) {
            toggleSticky(true);
            toggleVisibility(false);
        }
        if (scrollUp(currentScroll, prevScroll)) {
            toggleVisibility(true);
        }
        if (containerDivIsInWindow(containerDiv)) {
            toggleSticky(false);
            toggleVisibility(false);
        }

        setPrevScroll(currentScroll);

    }, [prevScroll]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };

    }, [handleScroll]);

    return (
        <div className="sticky-hoc" ref={containerDiv}>
            <div className={classNames('sticky-wrapper', { 'is-sticky': isSticky }, { 'is-visible': isVisible })}>
                {children}
            </div>
        </div >
    );
};

export default StickyComponent;
